import { IWindow } from '../static/interfaces'
declare var window: IWindow

export const pushDataLayer = data => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(data)
}
